// Swappable site integrations. Each is inert until its value is set, so nothing
// half-wired ever ships; set the value and the feature turns on (no code change).
export const SITE = {
  /** Google Ads tag ('AW-XXXX'), loaded sitewide for Ad Grant conversion tracking.
   *  Empty = off. From "Set up a Google tag on your website". */
  ANALYTICS_ID: 'AW-18552150149',
  /** GA4 Measurement ID ('G-XXXXXXX') for website analytics. Loads alongside the
   *  Ads tag. Empty until a GA4 property is created; paste the id here to activate. */
  GA4_ID: '',
  /** Google Ads "Submit lead form" conversion target (send_to = tag/label). Fired
   *  when a volunteer, contact, referral, or partner form is submitted. '' = off. */
  LEAD_CONVERSION: 'AW-18552150149/lqa0CIy30rAdEIWxrY5F',
  /**
   * Newsletter signup POST endpoint = the MailerLite classic-embed *subscribe* URL,
   * e.g. 'https://assets.mailerlite.com/jsonp/<ACCOUNT>/forms/<FORM_ID>/subscribe'
   * (from MailerLite → Forms → Embedded form → HTML code, the <form action="…">).
   * Empty = the signup falls back to a mailto to ORG_EMAIL (functional, never broken).
   * Left empty on purpose: the account used during development was a test account.
   * Paste the client's real subscribe URL here to activate MailerLite (no other change).
   */
  NEWSLETTER_ACTION: '',
  /** Org email, used for mailto fallbacks. */
  ORG_EMAIL: 'info@mayahouse.org',
  /** Where the referral form is delivered. */
  REFERRAL_EMAIL: 'Referrals@mayahouse.org',
  /** POST endpoint for referrals. Our self-hosted PHP handler emails Referrals@;
   *  set to '' to fall back to a mailto to REFERRAL_EMAIL (never broken). */
  REFERRAL_ACTION: '/form-submit.php',
  /** POST endpoint for volunteer signups. Our self-hosted PHP handler emails the
   *  org inbox; set to '' to fall back to a mailto to ORG_EMAIL (never broken). */
  VOLUNTEER_ACTION: '/form-submit.php',
  /** POST endpoint for contact messages. Our self-hosted PHP handler emails the
   *  org inbox; set to '' to fall back to a mailto to ORG_EMAIL (never broken). */
  CONTACT_ACTION: '/form-submit.php',
  /** Where the partner onboarding form is delivered. */
  PARTNER_EMAIL: 'partner@mayahouse.org',
  /** POST endpoint for partner inquiries. Our self-hosted PHP handler emails the
   *  partner inbox; set to '' to fall back to a mailto to PARTNER_EMAIL. */
  PARTNER_ACTION: '/form-submit.php',
}
